export const statuses = Object.freeze({
  pending: 'pending',
  succeeded: 'succeeded',
  rejected: 'rejected'
});
